<template>
  <v-data-table
    :headers="headers"
    :search="search"
    :items="
      getMotcle.map((x) => {
        var caract = getCharacteristique.find(
          (c) => c.id_caract === x.id_caract
        );
        return {
          ...x,
          nom_caract: caract.nom_caract,
        };
      })
    "
    :sort-by="['nom_caract', 'valeur']"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Recherche mot-clé"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#2B2118" dark class="mb-2" v-bind="attrs" v-on="on">
              <v-icon left>mdi-plus-circle</v-icon> Ajouter Mot-clé
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      disabled
                      v-model="editedItem.id_motcle"
                      label="ID Mot-clé"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-autocomplete
                      :items="getCharacteristique"
                      item-text="nom_caract"
                      item-value="id_caract"
                      label="Categorie"
                      v-model="editedItem.id_caract"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.valeur"
                      label="Nom Mot-clé"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#2B2118" text @click="close"> Annuler </v-btn>
              <v-btn
                :disabled="
                  editedItem.valeur === '' || editedItem.id_caract === ''
                "
                color="#2B2118"
                dark
                @click="save"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="700px">
          <v-card>
            <v-card-title class="headline"
              >Voulez-vous vraiment supprimer cet élément?</v-card-title
            >
            <v-card-text>
              <p style="word-break: keep-all">
                <span
                  >Genre: {{ editedItem.nom_caract }}
                  >
                  {{ editedItem.valeur }}
                </span>
              </p>
              <p style="word-break: keep-all">
                <span> L'opération n'est pas réversible. </span>
              </p>
              <p style="word-break: keep-all">
                <span>
                  Pour compléter l'opération, il faut d'abord éliminer les
                  associations à cette mot-clé dans la base de données.
                </span>
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#2B2118" dark @click="closeDelete">Annuler</v-btn>
              <v-btn color="#2B2118" text @click="deleteItemConfirm"
                >Supprimer cet élément</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Reset </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "ID Mot-clé",
        align: "start",
        value: "id_motcle",
      },
      { text: "Nom Mot-clé", value: "valeur" },
      { text: "Categorie", value: "nom_caract" },
      { text: "Actions", value: "actions", align: "right", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id_motcle: "",
      valeur: "",
      id_caract: "",
      nom_caract: "",
    },
    defaultItem: {
      id_motcle: "",
      valeur: "",
      id_caract: "",
      nom_caract: "",
    },
    search: "",
  }),

  computed: {
    ...mapGetters(["getMotcle", "getCharacteristique"]),
    formTitle() {
      return this.editedIndex === -1 ? "Ajouter Mot-clé" : "Modifier Mot-clé";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions(["addMotcle", "updateMotcle", "deleteMotcle"]),
    editItem(item) {
      this.editedIndex = this.getMotcle.findIndex(
        (gen) => gen.id_motcle === item.id_motcle
      );
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.getMotcle.findIndex(
        (gen) => gen.id_motcle === item.id_motcle
      );
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteMotcle(this.editedItem.id_motcle);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        this.updateMotcle(this.editedItem);
      } else {
        this.addMotcle(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style>
</style>